import { TypeChecker } from '@attain-apps/type-guards'

import type * as expression from '../../../expression'
import type { Context } from '../context'
import * as utils from '../utils'

import { Node } from './node'

/**
 * Represents a single selection which can aggregate the results from other
 * {@link Graph.Node}
 */
export class ForSingleton<out T = unknown> extends Node {
  /**
   * @see {@link Query.selection}
   */
  public readonly selection: expression.node.Node<T>

  constructor(params: ForSingleton.constructor.Params<T>) {
    super(params)
    this.selection = params.selection

    utils.SubqueryNodeLookup.consume(this, params.subqueryNodes, params)
  }
}
export namespace ForSingleton {
  export const isForSingleton: TypeChecker<ForSingleton> =
    TypeChecker.Factory.instance(ForSingleton).usingAlias(
      'query.graph.node.ForSingleton',
    )

  export namespace constructor {
    export interface Params<T = unknown>
      extends Node.constructor.Params,
        Pick<Context, 'schema'>,
        Pick<ForSingleton<T>, 'selection'> {
      subqueryNodes: utils.SubqueryNodeLookup
    }
  }
}
